import apiUrl from '../../../../constants'
import axios from 'axios'
//import Paginate from 'vuejs-paginate';
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import CryptoJS from 'crypto-js';
import download from 'downloadjs';
import Loader from './../../shared/loader'
import Pagination from './../../shared/pagination'
import csvHelper from '../importjsontocsv';

import Vue from "vue";
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);
import { BasicSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'
export default {
	name: 'POPutawayreport',
	components: {
		//Paginate,
		Pagination,
		DatePicker,
		JsonExcel,
		download,
		Loader,
		BasicSelect
	},
	props: [],
	data() {
		return {
			mid: '',
			listMerchantIdData: [],
			merchantnameFlt: '',
			reportname: '',
			csvFieldsForXls: {},
			listcancelPutawayReportDataforxls: [],
			listcancelPutawayReportData: [],
			listcancelPutawayReportDataCsv: [],
			dataFilterForXLS: [],
			csvFields: [],
			currentPage: 1,
			totalPage: 0,
			//totalCount:0,
			pageLimit: 10,

			// perPage: 10,
			// pageno: 0,
			totalRows: 0,
			// totalPage: 0,
			isLoading: false,
			formattedDate: '',
			resultCount: '',
			listClientData: [],
			listWarehouseData: [],
			ClientErr: '',
			WarehouseErr: '',
			searchFlag: false,
			showSelectWarehouse: false,
			showSelectClient: false,
			showSelectMerchant: false,
			clientid: '',
			warehouseid: '',
			warehouse: '',
			client: '',
			orderid: '',

			fromdate: '',
			todate: '',
			user_type: '',
			show: false,
			download: true,
			dataFilter2: '',
			isLoadingforxls: false,
			limitExeed: false,
			recordLimit: 0,
			item: {},
			merchant: '',
			listMerchantIdData1: [],
			merchantList: [],
			merchantname: '',
			activemrpflag:false,
		}
	},
	computed: {

	},
	filters: {
		moment: function (date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		}
	},
	mounted() {
		this.calldateFunction();
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.createdbyEmail = userdetail.email;
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		this.reportname =this.$t('editedjson.CancelPutawayReport')
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		this.user_type = userdetail.utype;
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		if(this.clientid!=='undefined' ){
			this.getMerchantList();
         }
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				this.showSelectMerchant = true;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				// this.getWarehouseList();
				this.getActiveMrpFlag();
				this.getMerchantList();
				this.showSelectWarehouse = true;
				this.showSelectMerchant = true;
				if (userdetail.merchantid) {
					this.mid = userdetail.merchantid.toString()
					this.merchantnameFlt = this.mid
					this.showSelectWarehouse = true;
					this.showSelectMerchant = false;
				}
				break;

			case 'warehouse_user':
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				this.showSelectMerchant = true;
				// this.getClientList();
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}
		this.getRecordLimit()

	},
	methods: {
		reset() {
			this.item = {}
		},
		onSelect(item) {

			this.item = item
			this.merchantnameFlt = item.value
		},
		getRecordLimit() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({

			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getRecordLimit',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data) {
						this.recordLimit = result.data.data;


					}
				}, error => {
					console.error(error)
				})
		},
		Choosetype() {
			this.show = true;
			this.download = false;
			if (!this.limitExeed) {
				this.getCancelPutawayReportDataForXLS(3);
			}

		},
		export(data, filename, mime) {
			let blob = this.base64ToBlob(data, mime);
			download(blob, filename, mime);
		},
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		calldateFunction: function () {
			this.currentDate = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
			this.todate = this.currentDate;
			var dt = new Date(this.currentDate);
			dt.setDate(dt.getDate() - 6);
			this.fromdate = dt;
		},
		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)));
			let bstr = atob(base64);
			let n = bstr.length;
			let u8arr = new Uint8ClampedArray(n);
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n);
			}
			return new Blob([u8arr], {
				type: mime
			})
		},

		// getClientList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.input = ({
		// 			warehouseid: this.warehouseid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },

		// getWarehouseList() {
		// 	this.pageno = 0;

		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 			.then(result => {
		// 				// console.log(result.data.data);
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },

		// clientSelected() {
		// 	if (this.clientid != this.client) {
		// 		this.clientid = this.client;
		// 		this.merchantnameFlt = '';
		// 		if (this.user_type != 'warehouse_user') {
		// 			this.listWarehouseData = []
		// 			this.getWarehouseList();
		// 			this.getActiveMrpFlag();
		// 			this.getMerchantList();
		// 			this.item = {}
		// 			if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 				this.warehouse = this.warehouseid = '';
		// 			} else {
		// 				this.warehouse = ''
		// 			}
		// 		} else {
		// 			if (this.warehouseid && this.clientid);
		// 			this.getMerchantList();
		// 			this.getActiveMrpFlag();
		// 			// this.getCancelPutawayReportData();
		// 		}
		// 	}
		// 	this.listcancelPutawayReportData = [];
		// 	this.pageno = this.totalPage = 0;
		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	this.pageno = this.totalPage = 0;
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {
		// 			// this.getCancelPutawayReportData();
		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },
		getMerchantList() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: this.clientid,
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'merchantList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {
					if (result.data && result.data.length > 0) {
						this.listMerchantIdData = result.data;
						var merchantlistArray = [];
						this.item = {
							value: '',
							text: ''
						};
						this.listMerchantIdData1 = [{
							value: '',
							text: this.$t('common.selectMerchantPlaceHolder')
						}];
						result.data.forEach(function (item) {
							merchantlistArray[item.merchantid] = item.merchantname;

						})
						this.merchantList = merchantlistArray;
						this.listMerchantIdData.forEach(ele => {
							this.listMerchantIdData1.push({
								"value": ele.merchantid,
								"text": ele.merchantname
							})
						})

					}
				}, error => {
					console.error(error);
				})
		},
		async getActiveMrpFlag(){
 				 var userToken = window.localStorage.getItem('userToken');
 				 var myStr = userToken.replace(/"/g, '');
 				 this.input = ({
 					 "clientid": this.clientid,
 				 });
 			 try {

 					 axios({
 							 method: 'POST',
 							 'url': apiUrl.api_url + 'checkActivemrpFlg',
 							 'data': this.input,
 							 headers: {
 								 'Authorization': 'Bearer ' + myStr,
 							 }
 						 })
 						 .then(result => {
 							 if(result.data.data.data[0].value ==='yes'){
 								 this.activemrpflag = true;
 							 }else{
 								 this.activemrpflag = false;
 							 }
 						 }, error => {
 							 console.error(error);
 						 });

 				 } catch (err) {
 					 throw new Error(err);
 				 }
 	 },
		getCancelPutawayReportDataSearch() {
			this.currentPage = 1;
			this.totalPage = 0;
			this.searchFlag = true;
			this.getCancelPutawayReportData(2);
		},
		//to get client list
		getCancelPutawayReportData(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var fr_date = '';
			var to_date = '';
			var dataFilter = {};
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
				this.limitExeed = false;
			}
			if (window.localStorage.getItem('selectedClient')==='undefined') {
				this.$alertify.error(this.$t('common.clientError'))
				this.pageno = this.totalPage = 0;
				this.listcancelPutawayReportData = [];
				return false;
			}
			if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageno = this.totalPage = 0;
				this.listcancelPutawayReportData = [];
				return false;
			}

			if (this.fromdate == '') {
				fr_date = '';
			} else {
				fr_date = this.dateFormat(this.fromdate, 0)
			}
			if (this.todate == '') {
				to_date = '';
			} else {
				to_date = this.dateFormat(this.todate, 1)
			}
			this.isLoading = true;
			this.input = ({
				clientid: this.clientid,
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				orderid: this.orderid.trim(),
				fromdate: fr_date,
				todate: to_date,
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				csvData: csvCheck,
				merchantid: this.merchantnameFlt,

			})
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getPutAwayCancelOrderReport',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (csvCheck == 1) {
						this.show = true;
						this.download = false;
						this.listcancelPutawayReportDataCsv = [];
						this.csvFields = {
							'orderid': this.$t('cancelPutawayPendingReport.orderId'),
							'createddatetime': this.$t('common.orderDate'),
							'cancelleddate': this.$t('cancelPutawayPendingReport.CancelledDate'),
							'productid': this.$t('product.table.columns.productID'),
							'eancode':  this.$t('product.table.columns.eanCode'),
							'productname': this.$t('product.table.columns.productName'),
							'mrp': this.$t('product.table.columns.mrp'),
							'activemrp': this.$t('common.activemrp'),
							'brand': this.$t('common.brand'),
							'boxid': this.$t('common.boxId'),
							'putawayqty': this.$t('editedjson.putawayQuantity'),
							'putawayrack': this.$t('common.rackID'),
							'putawayby':  this.$t('removeHold.putawayDoneBy'),
							'putawaydate': this.$t('removeHold.putawayDate'),
							'merchantname': this.$t('warehouseRacks.merchant'),

						};
						var dateFilter = [];
						if(this.activemrpflag === true){
						var skipFilter = ['count', 'merchantid'];
						}else {
							var skipFilter = ['count', 'merchantid','activemrp'];
						}
						this.listcancelPutawayReportDataCsv = result.data.data;

						csvHelper.data.jsonToCSV(this.$t('editedjson.CancelPutawayReport'), this.listcancelPutawayReportDataCsv, this.csvFields, dateFilter, skipFilter, dataFilter);

						// this.jsonToCSV('CancelPutawayReport', this.listcancelPutawayReportDataCsv, this.csvFields, dateFilter, skipFilter);

					} else {
						this.listcancelPutawayReportData = result.data.data;

						if (result.data.errorCode == -1) {
							this.resultCount = 0;
						} else {

							this.totalRows = Number(result.data.count)
							if (Number(this.totalRows) > Number(this.recordLimit)) {
								this.limitExeed = true
							}
							this.resultCount = result.data.count;
							if (this.totalRows < 10) {
								this.totalPage = 1
							} else {
								this.totalPage = Math.ceil(this.totalRows / 10);
							}
						}
					}
					this.isLoading = false;
				}, error => {
					console.error(error);
				})
		},



		getCancelPutawayReportDataForXLS(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var fr_date = '';
			var to_date = '';
			this.show = true;
			this.download = false;
			this.dataFilter2 = [];
			var value = '';
			var str = '';

			if (this.fromdate == '') {
				fr_date = '';
			} else {
				fr_date = this.dateFormat(this.fromdate, 0)
			}
			if (this.todate == '') {
				to_date = '';
			} else {
				to_date = this.dateFormat(this.todate, 1)
			}
			this.isLoading = true;
			this.input = ({
				clientid: this.clientid,
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				orderid: this.orderid.trim(),
				fromdate: fr_date,
				todate: to_date,
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				csvData: csvCheck,
				merchantid: this.merchantnameFlt,

			})
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getPutAwayCancelOrderReport',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (csvCheck == 3) {
						if (result.data.data.length > 0) {
							this.listcancelPutawayReportDataforxls = [];
							this.csvFieldsForXls =[];
							this.csvFieldsForXls[this.$t('warehouseRacks.rackId')] = 'orderid';
							this.csvFieldsForXls[this.$t('clientChannelMaster.createdDateTime')] ='createddatetime';
							this.csvFieldsForXls[this.$t('cancelPutawayPendingReport.CancelledDate')]= 'cancelleddate';
							this.csvFieldsForXls[this.$t('boxList.productPlaceholder')] = 'productid';
							this.csvFieldsForXls[this.$t('srmaster.table.eanCode')]=  'eancode';
							this.csvFieldsForXls[this.$t('printProductDetails.productName')] =  'productname';
							this.csvFieldsForXls[this.$t('printProductDetails.mrp')]=  'mrp';
							if(this.activemrpflag === true){
								this.csvFieldsForXls[this.$t('common.activemrp')]=  'activemrp';
						  }
							this.csvFieldsForXls[this.$t('common.brand')] = 'brand';
							this.csvFieldsForXls[this.$t('common.boxId')] = 'boxid';
							this.csvFieldsForXls[this.$t('removeHold.putawayQty')] = 'putawayqty';
							this.csvFieldsForXls[this.$t('cancelPutawayPendingReport.putAwayRack')] = 'putawayrack';
							this.csvFieldsForXls[this.$t('editedjson.putAwayBy')] =  'putawayby';
							this.csvFieldsForXls[this.$t('removeHold.putawayDate')] =  'putawaydate';
							this.csvFieldsForXls[this.$t('warehouseRacks.merchant')] = 'merchantname';


							this.listcancelPutawayReportDataforxls = result.data.data;

						} else {
							if (result.data.status == true) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}


					}


					this.isLoading = false;
				}, error => {
					console.error(error);
				})
		},
		//to get pagination
		// getPaginationData(pageNum) {
		//   this.pageno = (pageNum - 1) * this.perPage;
		//   this.getCancelPutawayReportData();
		// },
		onPageChange(page) {
			this.currentPage = page;
			this.getCancelPutawayReportData()
		},
		dateFormat(date, toFrom) {
			if (!toFrom)
				toFrom = '00:00:00'
			else
				toFrom = '23:59:59'
			if (!date)
				return '';
			return moment(date).format('YYYY-MM-DD ' + toFrom);
		},

		dateFormatFRT(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},

		//to reset search form
		resetSearchForm() {
			this.item = {}
			this.merchantnameFlt = '';
			this.show = false;
			this.download = true;
			this.productid = '';
			this.clientproductid = '';
			this.orderid = '';
			this.rackid = '';
			this.pageno = 0;
			this.totalRows = 0;
			this.listcancelPutawayReportData = [];
			this.fromdate = '';
			this.todate = '';
			this.searchFlag = false;
			// if (this.user_type == 'warehouse_user')
			// 	this.client = '';
			// else if (this.user_type == 'client_user')
			// 	this.warehouse = '';
			// else {
			// 	this.client = '';
			// 	this.warehouse = '';
			// }
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/reports/cancelPutawayReport/cancelPutawayReport.component.js